import React from 'react';
import { observer } from 'mobx-react';
import { OrderingDoctorListTemplate } from 'themes/application/ordering-doctor/pages';
import { setCurrentView } from 'core/utils';
import { OrderingDoctorListViewStore } from 'application/ordering-doctor/stores';

@setCurrentView((rootStore) => new OrderingDoctorListViewStore(rootStore), 'orderingDoctorListViewStore')
@observer
class OrderingDoctorList extends React.Component {
    render() {
        return <OrderingDoctorListTemplate {...this.props} />
    }
}

export default OrderingDoctorList;